<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item label="状态">
        <Select placeholder="全部状态" v-model="searchCondition.status" style="width:200px" clearable>
          <Option v-for="item in statusList" :value="item.status" :key="item.status">{{ item.name }}</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Input
          style="width:200px"
          placeholder="请输入资讯名称关键字"
          v-model="searchCondition.keywords"
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button style="margin-right:20px;" type="primary" :to="{name: 'NewsEdit'}">新建资讯</Button>
    <Checkbox @on-change="userCreate">只看我创建的</Checkbox>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        data-url="/api/information"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="none"
        keyField="id"
      >
        <template slot-scope="{ row }" slot="action">
          <Button
            @click="recommend(row.id)"
            type="text"
            size="small"
          >{{row.is_recommend == 2?'推荐':'取消推荐'}}</Button>-
          <Button type="text" size="small" @click="open(row)">{{row.status ? "禁用" : "启用"}}</Button>-
          <Button type="text" size="small" :to="{name: 'NewsEdit',query:{id:row.id}}">编辑</Button>-
          <Button type="text" size="small" @click="del('one',row.id)">删除</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "SettingAccount",
  data() {
    return {
      column: [
        {
          title: "资讯标题",
          key: "title",
          align: "center",
          minWidth: 120
        },
        {
          title: "所属分类",
          key: "classify",
          minWidth: 180,
          align: "center"
        },
        {
          title: "状态",
          key: "status_value",
          minWidth: 100,
          align: "center"
        },
        {
          title: "创建人",
          key: "nickname",
          minWidth: 180,
          align: "center"
        },
        {
          title: "创建时间",
          key: "created_at",
          minWidth: 180,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          minWidth: 220,
          align: "center",
          fixed: "right"
        }
      ],
      selectList: [],
      searchCondition: {
        keywords_type: 1,
        keywords: "",
        status: ""
      },
      position_status: "",
      statusList: [{ status: 1, name: "启用" }, { status: 0, name: "禁用" }]
    };
  },
  methods: {
    recommend(id) {
      this.$http.put("/api/information/recommend/" + id).then(() => {
        this.$refs.grid.refresh();
      });
    },
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.created_at = this.$pub.timestampToTime(i.created_at);
        i.status_value = i.status ? "启用" : "禁用";
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.keywords = "";
        this.searchCondition.status = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = val;
    },
    // 只看我创建点击
    userCreate: function(flag) {
      if (flag) {
        this.searchCondition.only_me = 1;
      } else {
        this.searchCondition.only_me = "";
      }
      this.search(1);
    },
    del(_type, _id) {
      let ids = "";
      if (_type == "one") {
        ids = _id;
      } else {
        if (this.selectList.length == 0) {
          this.$Message.error("请至少选择一个账号");
          return false;
        } else {
          let arr = [];
          this.selectList.forEach(i => {
            arr.push(i.uid);
          });
          ids = arr.join(",");
        }
      }
      this.$Modal.confirm({
        title: "删除",
        content: "<p>确定要删除该资讯吗？</p>",
        onOk: () => {
          this.delete(ids);
        },
        onCancel: () => {}
      });
    },
    delete(_ids) {
      this.$http.delete(`/api/information/${_ids}`).then(() => {
        this.search(1);
      });
    },
    open(row) {
      if (row.status == 1) {
        this.$Modal.confirm({
          title: "禁用",
          content: "<p>禁用后该资讯立即失效，在前台不显示，确认禁用吗？</p>",
          onOk: () => {
            this.$http.put(`/api/information/on/${row.id}`).then(() => {
              this.$refs.grid.refresh();
            });
          },
          onCancel: () => {}
        });
      } else {
        this.$Modal.confirm({
          title: "启用",
          content: "<p>启用后该资讯立即生效，可以在前台显示，确认启用吗？</p>",
          onOk: () => {
            this.$http.put(`/api/information/on/${row.id}`).then(() => {
              this.$refs.grid.refresh();
            });
          },
          onCancel: () => {}
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
